import React from "react";

const Footer = () => {
  return (
    <footer className="w-screen text-white bg-black">
      <div className="w-3/5 flex flex-wrap sm:justify-between justify-center  mx-auto items-center">
        <div className="flex flex-col gap-4 pb-8">
          <h1 className="pb-8 pt-8 text-2xl">Contact Deatils</h1>
          <div className="flex gap-2 items-center">
            <svg
              fill="white"
              className="w-5 h-5    "
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              {/*!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.*/}
              <path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
            </svg>

            <p className="text-xs md:text-sm">
              Chandani arcade building, 25/B, Chandani Chowk Street, Esplanade
            </p>
          </div>

          <div className="flex gap-2 items-center ">
            <svg
              className="w-5 h-5"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              {/*!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.*/}
              <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z" />
            </svg>

            <p className="text-xs md:text-sm"> +91 6289491639 / 8013141431 </p>
          </div>

          <div className="flex gap-2 items-center ">
            <svg
              className="h-5 w-5"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 512"
            >
              {/*!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.*/}
              <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0l57.4-43c23.9-59.8 79.7-103.3 146.3-109.8l13.9-10.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176 0 384c0 35.3 28.7 64 64 64l296.2 0C335.1 417.6 320 378.5 320 336c0-5.6 .3-11.1 .8-16.6l-26.4 19.8zM640 336a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 353.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z" />
            </svg>

            <p className="text-xs md:text-sm"> absinfotech512@gmail.com </p>
          </div>
        </div>

        {/* <div>
          <h1 className="pb-8 pt-4 text-2xl">Soical Links</h1>
          <Icons />
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
